<template>
  <z-dialogo 
    ref="dialogo"
    titulo="Compartilhar Conta"
    largura="800px"
    persistent
    scrollable
    @fechar="onFechar"
  >

   <template #prepend>
      <v-toolbar flat color="white">
        <v-autocomplete
          v-model="fornecedor_id"
          single-line
          dense
          clearable
          hide-details
          outlined
          label="Fornecedores"
          filled
          :items="listasStore.fornecedores"
          @click:clear="fornecedor_id = null"
          @change="listarContas"
        ></v-autocomplete>
      </v-toolbar>

    </template>

    <template v-slot:conteudo>
      
      <v-window v-model="step">
        <v-window-item :value="1">
          
          <v-card-text style="height: 400px;" class="pa-0">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="fornecedor_id"
                  single-line
                  dense
                  clearable
                  hide-details
                  outlined
                  label="Fornecedores"
                  filled
                  :items="listasStore.fornecedores"
                  @click:clear="fornecedor_id = null"
                  @change="listarContas"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <h1>Conteúdo 1</h1>

              </v-col>
            </v-row>



          </v-card-text>

        </v-window-item>
        <v-window-item :value="2">
          <h1>Conteúdo 2</h1>
        </v-window-item>
      </v-window>
    </template>

    <template v-slot:actions_left>
      <v-btn text @click="step--">
        Cancelar
      </v-btn>
      <v-btn depressed color="primary" @click="step++" :disabled="!form_valido">
        Salvar
      </v-btn>
    </template>

    <template v-slot:actions_right>
      <v-btn text @click="$refs.dialogo.fechar()">
        Cancelar
      </v-btn>
      <v-btn depressed color="primary" @click="$refs.dialogo.fechar()" :disabled="!form_valido">
        Salvar
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script setup>

import { ref, computed, getCurrentInstance, onMounted, inject } from 'vue';
import queryBuilder from '@/app/helpers/QueryBuilder';
import { useContasBancariasStore } from '@/app/store/pinia/contas';
import { useListasStore } from '@/app/store/pinia/listas';

const listasStore = useListasStore();
const contasBancariasStore = useContasBancariasStore();

const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $globals = proxy.$globals;
const $notificacao = inject('notificacao');
const dialogo = ref(null);
const form = ref(null);
const form_valido = ref(true);
const carregando = ref(false);
const step = ref(1);

const fornecedor_id = ref(null);

onMounted(async () => {
  // abrir();
});


function abrir() {
  buscarListas();
  dialogo.value.abrir();
}

function fechar() {
  onFechar();
  dialogo.value.fechar();
}

function onFechar() {
  fornecedor_id.value = null;
}

async function listarContas() {
  if (!fornecedor_id.value) {
    contasBancariasStore.limparContasBancarias();
    carregando.value = false;
    return;
  }
  
  
  try {
    carregando.value = true;
    await contasBancariasStore.listarContasBancarias(fornecedor_id.value);
    // if (movimentos.value.length === 0) {
    //   notificacao.adicionar({
    //     tipo: "info",
    //     mensagem: "Nenhum pedido de compra encontrado.",
    //   });
    // }
  } catch (error) {
    console.log(error);
  } finally {
    carregando.value = false;
  }
}

async function buscarListas() {
  await listasStore.fetchListas([
    queryBuilder()
      .from("Banco")
      .selectraw("id as value, concat(codigo, ' - ', descricao) as text")
      .orderBy("codigo")
      .build(),

      queryBuilder()
        .from("Fornecedor")
        .selectraw("id as value, razao as text, celular, telefone")
        .orderBy("razao")
        .build()
  ]);
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>
